import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonConfig from '../utils/constant';

const PreventedRoute = (props) => {
     const navigate = useNavigate();
    const loginData = CommonConfig.loginData('ERPLoginData');
    
    let meta = props.meta;
    React.useEffect(() => {
        document.title = meta.title;
    }, [meta])

    if (loginData) {
        CommonConfig.getUserMenu(loginData, navigate, 'Login');
    }
    return props.children;
};

export default PreventedRoute;